import { m } from "framer-motion";
import IconButton from "@mui/material/IconButton";
import Iconify from "src/components/iconify";
import Badge from "@mui/material/Badge";
import { RouterLink } from "src/routes/components";
import { paths } from "src/routes/paths";
import { Link } from "@mui/material";
import { useGetProviderUnreadMessageNr } from "src/api/provider";

// ----------------------------------------------------------------------

type Props = {
  currentProvider: number;
};

export default function MessagesIcon({ currentProvider }: Props) {
  const { messageData, messageNumberLoading, messageNumberError } =
    useGetProviderUnreadMessageNr(currentProvider);

  const { messageNumber } = messageData;

  return (
    <>
      {!messageNumberLoading && !messageNumberError && (
        <IconButton
          component={m.button}
          sx={{
            width: 40,
            height: 40,
          }}
        >
          <Badge badgeContent={messageNumber} color="error">
            <Link
              component={RouterLink}
              color="inherit"
              href={paths.dashboard.chat}
            >
              <Iconify
                icon="ooui:message"
                sx={{ borderRadius: 0.65, width: 28 }}
              />
            </Link>
          </Badge>
        </IconButton>
      )}
    </>
  );
}
